
export enum ShipperCountryCd {
	CANADA = 'Canada',
	MEXICO = 'Mexico',
	UNITED_STATES = 'United States'}

